import {
  Drawer as MuiDrawer,
  DrawerProps as MuiDrawerProps,
  Stack
} from '@mui/material'
import { NoiseBackground } from 'styles/rootPages/404.style'

interface DrawerProps extends MuiDrawerProps {
  overflowHidden?: boolean
  height?: string | number
}

export const Drawer = ({
  children,
  overflowHidden,
  height,
  ...props
}: DrawerProps) => (
  <MuiDrawer {...props}>
    <NoiseBackground />
    <Stack
      position="relative"
      overflow={overflowHidden ? 'hidden' : 'auto'}
      height={height}
    >
      {children}
    </Stack>
  </MuiDrawer>
)
